import useSWR from 'swr';
import { PAYMENTS_URL } from '@ordermentum/ui-constants';
import { fetcher } from '../../swr/fetchers';

type BSBValidationResponse = {
  name: string;
};

/**
 * Validates an Australian BSB number and returns the financial institution name.
 *
 * @param bsb - The 6-digit BSB number to validate
 * @returns SWR response with the financial institution name
 *
 * @example
 * const { data, isLoading, error } = useBSBValidation('063000');
 * // data?.name = 'Commonwealth Bank of Australia'
 */
export const useBSBValidation = (bsb: string) => {
  const isValidBSB = bsb?.length >= 6;

  return useSWR<BSBValidationResponse>(
    isValidBSB ? `${PAYMENTS_URL}/v1/validate/bsb?value=${bsb}` : null,
    fetcher(),
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );
};

export default useBSBValidation;
